import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer } from "recharts";
import logo from "components/pte-logo-new.svg";
import API, { base } from "api.js";
import { store, persistor } from "store/index";
import Unauthorized from "components/Exceptions/Unauthorized";
import SidebarClose from "components/Sidebar/SidebarClose";
import { useParams } from "react-router-dom";
import LaLoader from "components/Loader/LaLoader";
import "./Score.css";

const Result = (props) => {
  const [state, setState] = useState({
    result: {},
    com: [],
    enable: [],
    factor: [],
    total: 0,
    time: 0,
    score_text: "",
    unauthorized: false,
    isLoaded: false,
    viewType: "linear",
  });

  const { id } = useParams()
  const getBarWidth = (score) => `${(score / 90) * 100}%`;
  useEffect(() => {
    document.body.classList.toggle("sidebar-mini");
    //document.querySelector('#minimizeSidebar').style.display = "none"
    API({
      method: "GET",
      url: "/mock/score/" + id
    })
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          isLoaded: true,
        }));
        if (
          !data.data.data.auth &&
          data.data.message === "unauthorized access"
        ) {
          setState((prevState) => ({
            ...prevState,
            unauthorized: true,
          }));
        }
        setState((prevState) => ({
          ...prevState,
          score_text: data.data.data.text,
          factor: data.data.data.factor,
          com: data.data.data.com,
          enable: data.data.data.enable,
          total: data.data.data.total,
          time: data.data.data.time.split("T")[0],
        }));
      })
      .catch(() => { });

    return () => {
      document.body.classList.toggle("sidebar-mini");
      //document.querySelector('#minimizeSidebar').style.display = "block"
    };
  }, [id]);

  const showScore = (e, id) => {
    setState((prevState) => ({
      ...prevState,
      modal: !prevState.modal,
      id: id,
    }));
  };

  return (
    <>
      {!state.isLoaded ? (
        <><LaLoader show={!state.isLoaded} /></>
      ) : (
        <>
          {!state.unauthorized ? (
            <>
              <div className="content questionsArea">
                {/* <SidebarClose /> */}
                {false && (
                  <div className="row align-items-center">
                    <div className="col-sm-12">
                      <ul className="connectList">
                        <li className="cross">
                          <span>
                            1. When you stress them, they experience damage,
                            which is a good thing.
                          </span>
                        </li>
                        <li className="cross">
                          <span>
                            1. When you stress them, they experience damage,
                            which is a good thing.
                          </span>
                        </li>
                        <li className="cross">
                          <span>
                            1. When you stress them, they experience damage,
                            which is a good thing.
                          </span>
                        </li>
                        <li className="cross">
                          <span>
                            1. When you stress them, they experience damage,
                            which is a good thing.
                          </span>
                        </li>
                        <li>
                          <span>
                            1. When you stress them, they experience damage,
                            which is a good thing.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <Row>
                  <Col xs={12}>
                    <Card>
                      <CardHeader>
                        <Row>
                          <Col xs={6}>
                            <CardTitle tag="h4"></CardTitle>
                          </Col>
                          <Col xs={6}>
                            <div className="text-right questionTime"></div>
                          </Col>
                        </Row>
                      </CardHeader>
                      <CardBody>
                        {/* This is the header  */}
                        {store.getState().is_main && (
                          <Row className="scoreHeader mb-5 unselectable">
                            <Col md={7}>
                                  <img src={logo} alt="ptelogo" />
                                  <span className="">
                                    Score Report Code:{" "}
                                    <samp>{state.total}</samp>
                                  </span>
                            </Col>
                            <Col  md={5} className="scoreFooter scoreFooterTop">
                                  <div className="call">
                                    <i
                                      className="fa fa-phone"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    <a href="callto:+61426230061">
                                      +61426230061
                                    </a>
                                  </div>
                                  <div className="website">
                                    <i
                                      className="fa fa-globe"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    <a href="https://www.languageacademy.com.au/">
                                      www.languageacademy.com.au
                                    </a>
                                  </div>
                            </Col>
                          </Row>
                        )}
                        {/* This is the  end of the header  */}

                        {/* Modern Scorecard Section */}
                        <Card className="modern-scorecard mb-4">
                          <CardBody className="p-4">
                            {/* ROW 1: Avatar+Name (left) | Badge (right) */}
                            <div className="scorecard-header-row mb-4">
                              <div className="scorecard-user-info">
                                <img
                                  src={store.getState().user.image ? base + store.getState().user.image : "data:image/jpeg;base64,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"}
                                  alt="Avatar"
                                  className="avatar-circle"
                                />
                                <div className="ms-3">
                                  <h4 className="candidate-name mt-0 mb-1">
                                    {store.getState().user.first_name}{" "}
                                    {store.getState().user.last_name === "null" ? "" : store.getState().user.last_name}
                                  </h4>
                                  <p className="candidate-subtitle mb-0">Communication Skills</p>
                                </div>
                              </div>
                              {/* Right: Overall Score Badge */}
                              <div className="overall-score-badge">
                                <span className="overall-badge-number">{state.total}</span>
                                <span className="overall-badge-label">{state?.score_text}</span>
                              </div>
                            </div>

                            {/* ROW 2: 4 Score Circles full width */}
                            <div className="score-circles-container">
                              {state.com.hasOwnProperty("listening") && (
                                <div className="score-circle-wrapper">
                                  <div className="score-circle listening-circle">
                                    <span className="score-value">{state.com.listening}</span>
                                  </div>
                                  <p className="score-label">Listening</p>
                                </div>
                              )}
                              {state.com.hasOwnProperty("reading") && (
                                <div className="score-circle-wrapper">
                                  <div className="score-circle reading-circle">
                                    <span className="score-value">{state.com.reading}</span>
                                  </div>
                                  <p className="score-label">Reading</p>
                                </div>
                              )}
                              {state.com.hasOwnProperty("speaking") && (
                                <div className="score-circle-wrapper">
                                  <div className="score-circle speaking-circle">
                                    <span className="score-value">{state.com.speaking}</span>
                                  </div>
                                  <p className="score-label">Speaking</p>
                                </div>
                              )}
                              {state.com.hasOwnProperty("writting") && (
                                <div className="score-circle-wrapper">
                                  <div className="score-circle writing-circle">
                                    <span className="score-value">{state.com.writting}</span>
                                  </div>
                                  <p className="score-label">Writing</p>
                                </div>
                              )}
                            </div>
                          </CardBody>
                        </Card>

                        {/* Dashboard Main Layout Container (Fixed Height 505px) */}
                        <Row className="dashboard-main-container d-flex">
                          {/* Left Section (Column 1) */}
                          <Col lg={7} className="dashboard-column">
                            {/* Skill Breakdown (Fixed Height 402px) */}
                            <div className="dashboard-card-custom skill-breakdown-card">
                              <div className="dashboard-card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h3 className="section-title mb-0">Skill Breakdown</h3>
                                  <select 
                                    className="view-toggle-select"
                                    value={state.viewType}
                                    onChange={(e) => setState(prev => ({ ...prev, viewType: e.target.value }))}
                                  >
                                    <option value="linear">Linear View</option>
                                    <option value="radar">Radar View</option>
                                  </select>
                                </div>
                                <div className="row flex-grow-1 align-items-center justify-content-center">
                                  {state.viewType === "radar" ? (
                                    <div className="col-md-11">
                                      <div className="radar-chart-container" style={{ height: 400 }}>
                                        <ResponsiveContainer width="100%" height="100%">
                                          <RadarChart cx="50%" cy="50%" outerRadius="50%" data={[
                                            { skill: "Listening", score: state.com.listening || 0 },
                                            { skill: "Reading", score: state.com.reading || 0 },
                                            { skill: "Speaking", score: state.com.speaking || 0 },
                                            { skill: "Writing", score: state.com.writting || 0 },
                                          ]}>
                                            <PolarGrid stroke="#e0e0e0" />
                                            <PolarAngleAxis dataKey="skill" tick={{ fill: "#2c3e50", fontSize: 13, fontWeight: 600 }} />
                                            <PolarRadiusAxis 
                                              angle={90} 
                                              domain={[0, 90]} 
                                              ticks={[0, 20, 40, 60, 90]}
                                              tick={{ fill: "#7f8c8d", fontSize: 10 }} 
                                            />
                                            <Radar name="Score" dataKey="score" stroke="#9b59b6" fill="#9b59b6" fillOpacity={0.4} />
                                          </RadarChart>
                                        </ResponsiveContainer>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="col-md-10">
                                      <h5 className="comparison-title text-center mb-4">SCORE COMPARISON</h5>
                                      <div className="score-bars px-4">
                                        {state.com.hasOwnProperty("listening") && (
                                          <div className="bar-item">
                                            <span className="bar-label">Listening</span>
                                            <div className="bar-container">
                                              <div className="bar-fill bar-listening" style={{ width: getBarWidth(state.com.listening) }}></div>
                                              <span className="bar-value">{state.com.listening}</span>
                                            </div>
                                          </div>
                                        )}
                                        {state.com.hasOwnProperty("reading") && (
                                          <div className="bar-item">
                                            <span className="bar-label">Reading</span>
                                            <div className="bar-container">
                                              <div className="bar-fill bar-reading" style={{ width: getBarWidth(state.com.reading) }}></div>
                                              <span className="bar-value">{state.com.reading}</span>
                                            </div>
                                          </div>
                                        )}
                                        {state.com.hasOwnProperty("speaking") && (
                                          <div className="bar-item">
                                            <span className="bar-label">Speaking</span>
                                            <div className="bar-container">
                                              <div className="bar-fill bar-speaking" style={{ width: getBarWidth(state.com.speaking) }}></div>
                                              <span className="bar-value">{state.com.speaking}</span>
                                            </div>
                                          </div>
                                        )}
                                        {state.com.hasOwnProperty("writting") && (
                                          <div className="bar-item">
                                            <span className="bar-label">Writing</span>
                                            <div className="bar-container">
                                              <div className="bar-fill bar-writing" style={{ width: getBarWidth(state.com.writting) }}></div>
                                              <span className="bar-value">{state.com.writting}</span>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Sub Footer Banner (Fixed Height 90px) */}
                            <div className="score-sub-footer rounded-20 d-flex align-items-center justify-content-center">
                              <div className="sub-footer-content text-left px-5 ">
                                <h4 className="sub-footer-title mt-0 mb-1">Need a higher score?</h4>
                                <p className="sub-footer-text mb-0">
                                  Book a 1-on-1 session with our expert tutors to review the scorecard.
                                </p>
                              </div>
                            </div>
                          </Col>

                          {/* Right Section (Column 2) */}
                          <Col lg={5} className="dashboard-column">
                            {/* Candidate Details (Fixed Height 311px) */}
                            <div className="dashboard-card-custom candidate-details-box">
                              <div className="dashboard-card-body">
                                <h5 className="info-card-title">Candidate Details</h5>
                                <div className="info-item">
                                  <span className="info-label">Candidate ID</span>
                                  <span className="info-value">{store.getState().user.id ? `C-${store.getState().user.id}` : "N/A"}</span>
                                </div>
                                <div className="info-item">
                                  <span className="info-label">Email Id</span>
                                  <span className="info-value">{store.getState().user.email}</span>
                                </div>
                                
                              </div>
                            </div>

                            {/* Center Information (Fixed Height 182px) */}
                            <div className="dashboard-card-custom center-info-box">
                              <div className="dashboard-card-body justify-content-center">
                                <h5 className="info-card-title">Center Information</h5>
                                <div className="info-item">
                                  <span className="info-label">Center ID</span>
                                  <span className="info-value">Language Academy</span>
                                </div>
                                <div className="info-item">
                                  <span className="info-label">Type</span>
                                  <span className="info-value">Mock</span>
                                </div>
                                <div className="info-item">
                                  <span className="info-label">Center</span>
                                  <span className="info-value">Online</span>
                                </div>
                                 <div className="info-item">
                                  <span className="info-label">Test Date:</span>
                                  <span className="info-value">{state.time}</span>
                                </div>
                                 <div className="info-item">
                                  <span className="info-label">Valid Until: </span>
                                  <span className="info-value">{state.time}</span>
                                </div>
                                                  
                              </div>
                            </div>
                          </Col>
                        </Row>

                        {/* This is the footer  */}
                        {store.getState().is_main && (
                          <Row>
                            <Col xs={12}>
                              <div className="scoreFooter">
                                <span className="call">
                                  <i
                                    className="fa fa-phone"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  <a href="callto:+61426230061">
                                    +61426230061
                                  </a>
                                </span>
                                <span className="website">
                                  <i
                                    className="fa fa-globe"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  <a href="https://www.languageacademy.com.au/">
                                    www.languageacademy.com.au
                                  </a>
                                </span>
                              </div>
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col xs={12}>
                            <small>
                              <b>
                                This scorecard is not an official scorecard
                                and cannot be used for any official purposes.
                                The overall score in this mock test will give
                                you the closest idea of how much you will
                                score in the real exam but doesn’t represent
                                the exact score you will achieve in the exam.
                              </b>
                            </small>
                            <br />
                            {state.score_text !== "Overall Score" && (
                              <small>
                                Please note that this overall score is
                                calculated based on how you performed in this
                                particular section. In the full mock test or
                                real exam, your sectional score is calculated
                                by combining the transferable scores with the
                                sectional scores. For example, your writing
                                score is calculated as a sum of the Writing
                                section, Reading and Writing Blanks, Summarise
                                Spoken Text, Listening Fill in the Blanks, and
                                Write from Dictation. Therefore, in the exam
                                or full mock test, your score may vary
                                depending on your performance in the other
                                sections.
                              </small>
                            )}
                          </Col>
                        </Row>
                        {/* This is the end of the footer  */}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <Unauthorized />
          )}
        </>
      )}
    </>
  );
};

export default Result;


// import React, { Component } from "react";
// // reactstrap components
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Row,
//   Col,
// } from "reactstrap";
// // core components
// import logo from "components/ptelogo.png";
// import API, { base } from "api.js";
// import { store, persistor } from "store/index";
// import Unauthorized from "components/Exceptions/Unauthorized";
// import SidebarClose from "components/Sidebar/SidebarClose";
// class Result extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       result: {},
//       com: [],
//       enable: [],
//       factor: [],
//       total: 0,
//       time: 0,
//       score_text: "",
//       unauthorized: false,
//       isLoaded: false,
//     };
//   }

// componentDidMount() {
//   document.body.classList.toggle("sidebar-mini");
//   //document.querySelector('#minimizeSidebar').style.display = "none"
//   API({
//     method: "GET",
//     url: "/mock/score/" + this.props.match.params.id,
//   })
//     .then((data) => {
//       this.setState({ isLoaded: true });
//       if (
//         !data.data.data.auth &&
//         data.data.message === "unauthorized access"
//       ) {
//         this.setState({ unauthorized: true });
//       }
//       this.setState({
//         score_text: data.data.data.text,
//         factor: data.data.data.factor,
//         com: data.data.data.com,
//         enable: data.data.data.enable,
//         total: data.data.data.total,
//         time: data.data.data.time.split("T")[0],
//       });
//     })
//     .catch(() => { });
// }



// componentWillUnmount() {
//   document.body.classList.toggle("sidebar-mini");
//   //document.querySelector('#minimizeSidebar').style.display = "block"
// }
// showScore = (e, id) => {
//   this.setState({ modal: !this.state.modal, id: id });
// };
// render() {
// return(
//     <>
// { !this.state.isLoaded ? (
//   <></>
// ) : (
//   <>
//     {!this.state.unauthorized ? (
//       <>
//         <div className="content questionsArea">
//           {/* <SidebarClose /> */}
//           {false && (
//             <div className="row">
//               <div className="col-sm-12">
//                 <ul className="connectList">
//                   <li className="cross">
//                     <span>
//                       1. When you stress them, they experience damage,
//                       which is a good thing.
//                     </span>
//                   </li>
//                   <li className="cross">
//                     <span>
//                       1. When you stress them, they experience damage,
//                       which is a good thing.
//                     </span>
//                   </li>
//                   <li className="cross">
//                     <span>
//                       1. When you stress them, they experience damage,
//                       which is a good thing.
//                     </span>
//                   </li>
//                   <li className="cross">
//                     <span>
//                       1. When you stress them, they experience damage,
//                       which is a good thing.
//                     </span>
//                   </li>
//                   <li>
//                     <span>
//                       1. When you stress them, they experience damage,
//                       which is a good thing.
//                     </span>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           )}
//           <Row>
//             <Col xs={12}>
//               <Card>
//                 <CardHeader>
//                   <Row>
//                     <Col xs={6}>
//                       <CardTitle tag="h4"></CardTitle>
//                     </Col>
//                     <Col xs={6}>
//                       <div className="text-right questionTime"></div>
//                     </Col>
//                   </Row>
//                 </CardHeader>
//                 <CardBody>
//                   <Row className="unselectable">
//                     <div className="container">
//                       {store.getState().is_main && (
//                         <div className="scoreHeader mb-5 row">
//                           <div className="col-md-7">
//                             <img src={logo} alt="ptelogo" />
//                             <span className="">
//                               Score Report Code:{" "}
//                               <samp>{this.state.total}</samp>
//                             </span>
//                           </div>
//                           <div className="col-md-5 scoreFooter">
//                             <div className="call">
//                               <i
//                                 className="fa fa-phone"
//                                 aria-hidden="true"
//                               ></i>{" "}
//                               <a href="callto:+61426230061">
//                                 +61426230061
//                               </a>
//                             </div>
//                             <div className="website">
//                               <i
//                                 className="fa fa-globe"
//                                 aria-hidden="true"
//                               ></i>{" "}
//                               <a href="https://www.languageacademy.com.au/">
//                                 www.languageacademy.com.au
//                               </a>
//                             </div>
//                           </div>
//                         </div>
//                       )}

//                       <div className="scorecard row mb-5">
//                         <div className="col scoreUserImg">
//                           <div className="scoreImgOuter">
//                             <img
//                               src={
//                                 store.getState().user.image
//                                   ? base + store.getState().user.image
//                                   : "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAAMAUExURevr7Jydn5manJucnuPj5JiZm9vb3PT09MvLzMLCw5GSlPr6+qeoqdXV1tHR0rW1trW2uKusrbi4urO0tLq6vKiqq7e4uLW2tqGipLm6ury8vr6+vr+/wLu8vM7OztDQ0cjJytjY2dTU1aipqqqrrMXGxqanqKmqq6Wmp9LT062usKSlprS0ta2trra2t6ytrqWmqK2ur66vsK6ur7CwsbOztK+vsK+wsbKys7GxsqOkpqOkpZ6foampq6qqrJ2eoKenqaysraKjpZqbnbi4uaKjpKSlp5eYmqioqqurrKChory8vKGio6amqKCho7Gys7CxsrGysrKzs5+gop+gobS1tbq6u7e3uLCxsbKztLi4uJWWmJaXmba3t7i5ub29vZWXmZSWmLq6upOVl5SVl7m5up6foLq7u7u7vJqcnZOUlpeZm5aYmpKUlry8vZKTlpGTlZCRlJCRk6ytr9bX197e3q+vsb2+v8DAweDh4bOztebm5ujp6e/v756eoP///4CAgIGBgYKCgoODg4SEhIWFhYaGhoeHh4iIiImJiYqKiouLi4yMjI2NjY6Ojo+Pj5CQkJGRkZKSkpOTk5SUlJWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnZ6enp+fn6CgoKGhoaKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq6ysrK2tra6urq+vr7CwsLGxsbKysrOzs7S0tLW1tba2tre3t7i4uLm5ubq6uru7u7y8vL29vb6+vr+/v8DAwMHBwcLCwsPDw8TExMXFxcbGxsfHx8jIyMnJycrKysvLy8zMzM3Nzc7Ozs/Pz9DQ0NHR0dLS0tPT09TU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OHh4eLi4uPj4+Tk5OXl5ebm5ufn5+jo6Onp6erq6uvr6+zs7O3t7e7u7u/v7/Dw8PHx8fLy8vPz8/T09PX19fb29vf39/j4+Pn5+fr6+vv7+/z8/P39/f7+/v///zfARREAAAeqSURBVHja7N3xVxJZFMBxQAQVilzPSTslBxcDdwdtBQRBDQUFBYNMDTcoNLAMM7QD23JozvvX94cJZBhQZ+bdO2/26F/Q59wv8K48JwP5n/wY7iH3kHvIPYT6D89bLBazfiF8Y+T09PT09MOHzc3Nd+8yeoTwb99+/PjkSbfj8eN83qYPSCOTOTs7O3veEP69UkcegEIdMpPJCI6zz5/f9p9HPp9//97KMsTwLZO5o2Nh4RmrkHrpmxzHwsICzyLEWSq1IXd1TE6aWYNYSqVSqSRzHpOTDsdDliC2ksBQ4HA4zOxA6iURRJ7DccizAbE9fVpyNXhlXTkcjsNDHxMQKyGEWBV35Tg89Pl8rKTVUtHVoc/n89mYgPBK3686Dt8EIcQwMzOjKUTF+1XHMbG0tLT095s3y8vL77WCqHq/Ehy+Lsdybm9aC4irRKGrLkcut7cXiUTQIS1588jfPo/cXiQSibxGhtTpdyU4kCElyq/zXMdx9AwT0qI+j1zbEQwiQmyUX+fXXR0Fg0EXGsQK1dXRUTAYDIbRIJBdBYNhNIgFsqtgOBx2IkFguwqHQyEcSAu2q3AICwLcVSjEh1oYEPCuQgbix4A4obsK+QmPAwHtKhTy+3+gvEacsF2F/H5/wIAIAevK7/cHAhgQgPNuzzwCgcAiFgSoK3/bgQWhuUdJuwosYkGgu1pcnDdgQCju5wPmMY8CAeyqPY/5+To8BKErPAjY50fb8QIHAnIu6Z7HCxwI0Lmk24ECge8KB4LQ1YuNDYS3X4SuNjbGESAIXW2M40DAuxofH0c4ayF0hQNB6AoJAt8VDgShq/GdHQwIYFfteezMIkCgzrsiBwZkhPp+LulqFgXyB/X9XDoPFEgTviscCE99P+/+/PjlwIAQ6vu5dB4vX2JAALvaaTu8OBCoc0m7q5deHAjYuaQzD68fAwJ3Luk4vC4MyAh4V17vAwxIE7orr9fLY0AIdFde7xpBg8B09cuBCAHtyrvmxoLAdrXm/h0DUgfvas3tdvPQEBdCV2632+3eHgWFwL9ftR12+yYg5CfIfi7pyu3ettvtdkAI2B4lnYfdbndBQiD28wGO9XUwiAFmP5e8zu0CxGOFgrgQu1pf93hcUJA84HlX/DoXIDkoCNB+3r8rj8fjgYIA7ef9u4KGoHXl8XheAUKAzyXdXXlezcFBwM8lXV29moODoHY1BwfB7QoSgtoVIARuj+rXFTAEtCvxPJKPoCBm1K6SyZ9gx3jorrodc0kObh/B7CrJzQJCELviZA1EJsQAtp9LuwKFENA9SjwPbhoSYgbbzwVGl0PeQGT/gg5sP+/tipuFhRCkruQORD5kFPa8qzAsJb/Ehj3v/uqKM8NDSANmPxd11cD5fgS8K5Q/3yOE2L7l9vYWALpKPuI4jsP7M3DhB+JcovyBbmoeJ0K/K45oASG0u0py09pAND7v0oM0qe7nSU4zCKG7R2kJofw5yGsFcVLcz1UOROXztah2pSWE6vkqatUO0qS2n3McFyXaQYiP2h6l0qH6qYCU9nMuGmUBon6P4qLRh9pCrJS6UjsQ9Q+cXKKwR3HRaPQfrSGESlfRFaI5pK7284OKg8aDiyl0tcIEpKV4j6LooPIoaYParlZ4NiBE2X5+7fiXMAIh6rpaIcxAeDVdUXHQem78A/n7ecfRYAlCphXsURTnQfG/JJC/RwkO9iCy9yjBEWcNoqyrlTiTEPldxZmEKOgqHt9iDyL782MlHo9vsQeRtZ9fO5iDyNyjOg72IIq62tqaYg0ib4+6drAJkd3VFJMQBV1NTe2yC5HTFZOQO+9R3fPYZQ4iu6spwcEq5PY9StTV7m6WLYjtVFlXu9nsCDMQi9+ruKtsNptOp9N/WTWHmJ/I2s8l88im0+n0/v7+Qc6mHcSiZI8a4Dg4OFhdVXGnRjHks9I9StpVx7G6uvrpU8yJCHmudD+/cR6CIxaLxR5gQJT/3ufOjljMaDQ6ASHN18q+P5fRVcdhNBqNQ9tWAEhL+ffnCuZhNBqNQ0NDQ0N+qpCmyu85lTu+fEkkEnYLDcio6u/PFXbVcSQSiYTJ5FQFeU7le0518xAcJpPJNKMMUqL0/Tk1h2l4eHh4RB6kPkHlHvKA827HsS/bMXx+nvqtdUcItfvt9OcxfH6eSqVSqa8/boU06d2/AnR8LRaLN0Pq9O6339aVckfqa7FYLB7fBKF0DxlhHsXj42PjQEgIqqspCEehUBgA8dG5347S1fFxoVAo2PpCWrrqqlAoFE5OWn0gBr11VTg5Oan0gdC63w45j1Svo2KVQujdQ8bq6qRSqVQkkAlq95DxuqpUKmUJhNb9dsyuKpVyeVQC0WNX5XK52gOx6LKrcrlabYghE5Tut+N2VS5Xq3YxhNo9ZNyuqtXqhQhipXS/HburavVCDKkzvUcN7qp60QPZ1GtXFxc1EYTV/fwaMmgetV4Iu/v5jV3VarW6CML2fj64q1qt9mc3hPX9fPA8ape9ED3sUX3mcXl5KYboY4/q5xgTQdjfz/t31QvRb1djYz0QvXYlhbC/n/ftqgeinz1KMo8eiG72KKlDBNHPHtXbVT+ILrsaG7vqgei0q6ur770QfXZ19V2A/DcAHpmC7NcZ4/wAAAAASUVORK5CYII="
//                               }
//                               alt="Avatar"
//                             />
//                           </div>
//                         </div>
//                         <div className="col scoreBlock">
//                           <h3>
//                             {store.getState().user.first_name}{" "}
//                             {store.getState().user.last_name}
//                           </h3>
//                           <p>Communicative Skills</p>
//                           <div className="row text-center">
//                             {this.state.com.hasOwnProperty(
//                               "listening"
//                             ) && (
//                                 <div className="col listening">
//                                   <div className="scoreNumber">
//                                     {this.state.com.listening}
//                                   </div>
//                                   <span>Listening</span>
//                                 </div>
//                               )}
//                             {this.state.com.hasOwnProperty(
//                               "reading"
//                             ) && (
//                                 <div className="col reading">
//                                   <div className="scoreNumber">
//                                     {this.state.com.reading}
//                                   </div>
//                                   <span>Reading</span>
//                                 </div>
//                               )}
//                             {this.state.com.hasOwnProperty(
//                               "speaking"
//                             ) && (
//                                 <div className="col speaking">
//                                   <div className="scoreNumber">
//                                     {this.state.com.speaking}
//                                   </div>
//                                   <span>Speaking</span>
//                                 </div>
//                               )}
//                             {this.state.com.hasOwnProperty(
//                               "writting"
//                             ) && (
//                                 <div className="col writing">
//                                   <div className="scoreNumber">
//                                     {this.state.com.writting}
//                                   </div>
//                                   <span>Writing</span>
//                                 </div>
//                               )}
//                           </div>
//                         </div>
//                         <div className="col overallScore">
//                           <div className="overallScoreInr">
//                             <span>{this.state.score_text}</span>
//                             <samp>{this.state.total}</samp>
//                           </div>
//                         </div>
//                       </div>

//                       {store.getState().is_main && (
//                         <div className="row comucationSkills mb-5">
//                           <div className="col-sm-12">
//                             <div className="languageLogo">
//                               <img src={logo} alt="ptelogo" />
//                             </div>
//                           </div>
//                         </div>
//                       )}

//                       <div className="row skillsBreakdown mb-5">
//                         <div className="col-sm-7">
//                           <h3>Skills Breakdown</h3>
//                           <div className="skilsNscore">
//                             {this.state.total && (
//                               <div className="overallBar">
//                                 <span>
//                                   <samp
//                                     className="bar"
//                                     style={{
//                                       left: this.state.total + "%",
//                                     }}
//                                   ></samp>
//                                   <samp
//                                     className="score"
//                                     style={{
//                                       left: this.state.total + "%",
//                                     }}
//                                   >
//                                     {this.state.total} Overall
//                                   </samp>
//                                 </span>
//                               </div>
//                             )}
//                             <ul>
//                               {this.state.com.hasOwnProperty(
//                                 "listening"
//                               ) && (
//                                   <li className="listening">
//                                     <label>
//                                       Listening{" "}
//                                       <i
//                                         className="fa fa-info-circle"
//                                         title={
//                                           "out of " +
//                                           (this.state.factor["listen"] +
//                                             10)
//                                         }
//                                         aria-hidden="true"
//                                       ></i>
//                                     </label>
//                                     <div className="numberBar">
//                                       <span className="number">
//                                         {this.state.com.listening}
//                                       </span>
//                                       <div className="bar">
//                                         <samp
//                                           style={{
//                                             width:
//                                               this.state.com.listening +
//                                               "%",
//                                           }}
//                                         ></samp>
//                                       </div>
//                                     </div>
//                                   </li>
//                                 )}
//                               {this.state.com.hasOwnProperty(
//                                 "reading"
//                               ) && (
//                                   <li className="reading">
//                                     <label>
//                                       Reading{" "}
//                                       <i
//                                         className="fa fa-info-circle"
//                                         title={
//                                           "out of " +
//                                           (this.state.factor["read"] + 10)
//                                         }
//                                         aria-hidden="true"
//                                       ></i>
//                                     </label>
//                                     <div className="numberBar">
//                                       <span className="number">
//                                         {this.state.com.reading}
//                                       </span>
//                                       <div className="bar">
//                                         <samp
//                                           style={{
//                                             width:
//                                               this.state.com.reading +
//                                               "%",
//                                           }}
//                                         ></samp>
//                                       </div>
//                                     </div>
//                                   </li>
//                                 )}
//                               {this.state.com.hasOwnProperty(
//                                 "speaking"
//                               ) && (
//                                   <li className="speaking">
//                                     <label>
//                                       Speaking{" "}
//                                       <i
//                                         className="fa fa-info-circle"
//                                         aria-hidden="true"
//                                         title={
//                                           "out of " +
//                                           (this.state.factor["speak"] +
//                                             10)
//                                         }
//                                       ></i>
//                                     </label>
//                                     <div className="numberBar">
//                                       <span className="number">
//                                         {this.state.com.speaking}
//                                       </span>
//                                       <div className="bar">
//                                         <samp
//                                           style={{
//                                             width:
//                                               this.state.com.speaking +
//                                               "%",
//                                           }}
//                                         ></samp>
//                                       </div>
//                                     </div>
//                                   </li>
//                                 )}
//                               {this.state.com.hasOwnProperty(
//                                 "writting"
//                               ) && (
//                                   <li className="writing">
//                                     <label>
//                                       Writing{" "}
//                                       <i
//                                         className="fa fa-info-circle"
//                                         aria-hidden="true"
//                                         title={
//                                           "out of " +
//                                           (this.state.factor["write"] +
//                                             10)
//                                         }
//                                       ></i>
//                                     </label>
//                                     <div className="numberBar">
//                                       <span className="number">
//                                         {this.state.com.writting}
//                                       </span>
//                                       <div className="bar">
//                                         <samp
//                                           style={{
//                                             width:
//                                               this.state.com.writting +
//                                               "%",
//                                           }}
//                                         ></samp>
//                                       </div>
//                                     </div>
//                                   </li>
//                                 )}
//                             </ul>
//                           </div>
//                         </div>
//                         <div className="col-sm-5 infoBlock">
//                           <h3>Candidate Information</h3>
//                           <div className="infoOuter">
//                             <p>
//                               <b>Date of Birth: </b>
//                               {store.getState().user.dob}
//                             </p>
//                             <p>
//                               <b>Country of Citizenship: </b>
//                               {
//                                 store.getState().user
//                                   .country_citizenship
//                               }
//                             </p>
//                             <p>
//                               <b>Country of Residence: </b>
//                               {store.getState().user.country_residence}
//                             </p>
//                             <p>
//                               <b>Email: </b>
//                               {store.getState().user.email}
//                             </p>
//                             <p>
//                               <b>First-Time Test Taker: </b>No
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="row skillsBreakdown mb-5">
//                         <h3 className="pb-4 mb-4 col-sm-12">
//                           Test Center Information
//                         </h3>
//                         <p className="col-sm-7">
//                           <b>Test Date: </b>
//                           {this.state.time}
//                         </p>
//                         <p className="col-sm-5">
//                           <b>Valid Until: </b>
//                           {this.state.time}
//                         </p>
//                         <p className="col-sm-7">
//                           <b>Report issue date: </b>
//                           {this.state.time}
//                         </p>
//                         <p className="col-sm-5">
//                           <b>Test Center Country: </b>
//                           {store.getState().user.country_residence}
//                         </p>
//                         <p className="col-sm-7">
//                           <b>Test Centre ID: </b>LanguageAcademy
//                         </p>
//                         <p className="col-sm-5">
//                           <b>Test Centre: </b>online
//                         </p>
//                       </div>
//                       {store.getState().is_main && (
//                         <div className="scoreFooter">
//                           <span className="call">
//                             <i
//                               className="fa fa-phone"
//                               aria-hidden="true"
//                             ></i>{" "}
//                             <a href="callto:+61426230061">
//                               +61426230061
//                             </a>
//                           </span>
//                           <span className="website">
//                             <i
//                               className="fa fa-globe"
//                               aria-hidden="true"
//                             ></i>{" "}
//                             <a href="https://www.languageacademy.com.au/">
//                               www.languageacademy.com.au
//                             </a>
//                           </span>
//                         </div>
//                       )}
//                       <small>
//                         <b>
//                           This scorecard is not an official scorecard
//                           and cannot be used for any official purposes.
//                           The overall score in this mock test will give
//                           you the closest idea of how much you will
//                           score in the real exam but doesn’t represent
//                           the exact score you will achieve in the exam.
//                         </b>
//                       </small>
//                       <br />
//                       {this.state.score_text != "Overall Score" && (
//                         <small>
//                           Please note that this overall score is
//                           calculated based on how you performed in this
//                           particular section. In the full mock test or
//                           real exam, your sectional score is calculated
//                           by combining the transferable scores with the
//                           sectional scores. For example, your writing
//                           score is calculated as a sum of the Writing
//                           section, Reading and Writing Blanks, Summarise
//                           Spoken Text, Listening Fill in the Blanks, and
//                           Write from Dictation. Therefore, in the exam
//                           or full mock test, your score may vary
//                           depending on your performance in the other
//                           sections.
//                         </small>
//                       )}
//                     </div>
//                   </Row>
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//         </div>
//       </>
//     ) : (
//       <Unauthorized />
//     )}
//   </>
// )}
//     </>
//   );
// }
// }
// export default Result;
